<template>
  <div class="c-p" @click="toCompany">{{ params.data.company_name }}</div>
</template>

<script>
export default {
  methods: {
    toCompany: function () {
      let routeUrl = this.$router.resolve({
        path: "/home/client/client_dashboard",
        query: { id: this.params.data.company_id },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
